export default class {
  constructor (assu) {
    this.code = assu ? assu.code : ''
    this.language = assu ? assu.language : ''
    this.value = assu ? assu.value : ''
  }
}
